import { CardsList } from '../types/card';

export const CARDS_LIST: CardsList = [
  {
    id: 'id_1',
    title: 'smilingFaceWithSunglasses',
    front: '😎'
  },
  {
    id: 'id_2',
    title: 'faceWithSymbolsOverMouth',
    front: '🤬'
  },
  {
    id: 'id_3',
    title: 'pileOfPoop',
    front: '💩'
  },
  {
    id: 'id_4',
    title: 'ghost',
    front: '👻'
  },
  {
    id: 'id_5',
    title: 'jackOLantern',
    front: '🎃'
  },
  {
    id: 'id_6',
    title: 'topHat',
    front: '🎩'
  },
  {
    id: 'id_7',
    title: 'cool',
    front: '🐛'
  },
  {
    id: 'id_8',
    title: 'bug',
    front: '🦖'
  },
  {
    id: 'id_9',
    title: 'fourLeafClover',
    front: '🍀'
  },
  {
    id: 'id_10',
    title: 'fullMoon',
    front: '🌕'
  },
  {
    id: 'id_11',
    title: 'cherryBlossom',
    front: '🌸'
  },
  {
    id: 'id_12',
    title: 'mushroom',
    front: '🍄'
  },
  {
    id: 'id_13',
    title: 'globeShowingAsiaAndAustralia',
    front: '🌏'
  },
  {
    id: 'id_14',
    title: 'rainbow',
    front: '🌈'
  },
  {
    id: 'id_15',
    title: 'avocado',
    front: '🥑'
  },
  {
    id: 'id_16',
    title: 'peaceSymbol',
    front: '☮️'
  },
  {
    id: 'id_17',
    title: 'redHeart',
    front: '❤️'
  },
  {
    id: 'id_18',
    title: 'billiards',
    front: '🎱'
  }
];
